import { ArrowRight, Briefcase, Palette, Users, LineChart } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const highlights = [
  {
    icon: Users,
    title: 'Customer and Team Control',
    description: 'Manage reseller customers or internal agency members from one partner area.',
  },
  {
    icon: Palette,
    title: 'Brand-led Experience',
    description: 'Show your branding in communications and reports for partner-managed accounts.',
  },
  {
    icon: LineChart,
    title: 'Unified Visibility',
    description: 'Agency-exclusive: shared resources and analysis across agency team members in one main dashboard.',
  },
  {
    icon: Briefcase,
    title: 'Built for Service Teams',
    description: 'Designed for agencies, firms, and service-led teams operating at scale.',
  },
];

const PartnerProgramSection = () => (
  <section className="py-14 md:py-16 bg-cv-sky/10">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="py-2">
          <div className="grid lg:grid-cols-[1.2fr_1fr] gap-8 items-start">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cv-sky/10 border border-cv-sky/30 text-cv-navy text-xs font-bold tracking-wider uppercase mb-4">
                Partner Program
              </span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy leading-tight">
                Build Your Partner Area with Crawler Vision
              </h2>
              <p className="mt-4 text-cv-navy/70 text-base sm:text-lg max-w-2xl">
                Launch your partner workflow with role-based access, branded reporting, and centralized visibility for managed accounts.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <a
                  href="/partner/register"
                  className="inline-flex items-center gap-2 rounded-xl bg-cv-navy text-white px-6 py-3 font-semibold hover:bg-cv-navy transition"
                >
                  Become a Partner <ArrowRight className="w-4 h-4" />
                </a>
                <a
                  href="/partner-program"
                  className="inline-flex items-center gap-2 rounded-xl border border-cv-sky/30 px-6 py-3 font-semibold text-cv-navy hover:bg-cv-sky/10 transition"
                >
                  Explore Program
                </a>
              </div>

              <div className="mt-6 inline-flex items-center gap-3 rounded-2xl bg-white/80 px-4 py-3 shadow-sm">
                <div className="w-12 h-12 rounded-xl bg-cv-sky/20 flex items-center justify-center text-2xl">
                  🤝
                </div>
                <div>
                  <p className="text-sm font-semibold text-cv-navy">Partnership, not just access</p>
                  <p className="text-xs text-cv-navy/70">Built for long-term reseller and agency growth.</p>
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-3">
              {highlights.map((item) => (
                <div key={item.title} className="rounded-xl bg-white/70 p-4">
                  <item.icon className="w-5 h-5 text-cv-navy mb-2" />
                  <h3 className="font-semibold text-sm text-cv-navy">{item.title}</h3>
                  <p className="text-xs text-cv-navy/70 mt-1 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default PartnerProgramSection;
